import React, { useState, useEffect } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "../../core/json/siderbar_data";
import HorizontalSidebar from "./horizontalSidebar";
import CollapsedSidebar from "./collapsedSidebar";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getProfileTest } from "../../core/api/auth.js";
import { hasRoutePermission } from "../../core/utils/permissionHelpers";
import { useSelector } from "react-redux";

const Sidebar = () => {
  const Location = useLocation();
  const profile = useSelector((state) => state.profile);
  console.log("Profile from Sidebar:", profile);

  // State to hold the user profile
  const [user, setUser] = useState(null);
  const [userLoading, setUserLoading] = useState(true);

  // State for sidebar dropdowns
  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");


  const toggleSidebar = (title) => setSubopen(title === subOpen ? "" : title);
  const toggleSubsidebar = (subitem) =>
    setSubsidebar(subitem === subsidebar ? "" : subitem);
const canViewLink = (link) => {
  return hasRoutePermission(profile, link);
};

  const filteredSidebarData = SidebarData.map((mainLabel) => {
    const filteredSubmenus = (mainLabel.submenuItems || []).filter((item) => {
      if (profile?.role === "admin" && item.link === "/access-control") {
        return true;
      }
      return canViewLink(item.link);
    });
    if (filteredSubmenus.length > 0) {
      return { ...mainLabel, submenuItems: filteredSubmenus };
    }
    return null;
  }).filter(Boolean);

  if (!profile) return null;
  if (profile.role === "super_admin" && filteredSidebarData.length === 0)
    return null;

  return (
    <div>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {(profile.role === "super_admin"
                  ? SidebarData
                  : filteredSidebarData
                )?.map((mainLabel, index) => (
                  <li className="submenu-open" key={index}>
                    <h6 className="submenu-hdr">{mainLabel?.label}</h6>
                    <ul>
                      {mainLabel?.submenuItems?.map((title, i) => {
                        let link_array = [];
                        title?.submenuItems?.map((link) => {
                          link_array.push(link?.link);
                          if (link?.submenu) {
                            link?.submenuItems?.map((item) => {
                              link_array.push(item?.link);
                            });
                          }
                          return link_array;
                        });
                        title.links = link_array;
                        return (
                          <React.Fragment key={i}>
                            <li
                              className={`submenu ${
                                !title?.submenu &&
                                Location.pathname === title?.link
                                  ? "custom-active-hassubroute-false"
                                  : ""
                              }`}>
                              <Link
                                to={title?.link}
                                onClick={() => toggleSidebar(title?.label)}
                                className={`${
                                  subOpen === title?.label ? "subdrop" : ""
                                } ${
                                  title?.links?.includes(Location.pathname)
                                    ? "active"
                                    : ""
                                }`}>
                                <OverlayTrigger
                                  placement="right"
                                  delay={{ show: 100, hide: 100 }}
                                  trigger={["hover", "focus"]}
                                  overlay={(props) => (
                                    <Tooltip
                                      id={`tooltip-${title?.label}`}
                                      {...props}>
                                      {title?.label}
                                    </Tooltip>
                                  )}>
                                  {title?.icon}
                                </OverlayTrigger>
                                <span className="custom-active-span">
                                  {title?.label}
                                </span>
                                {title?.submenu && (
                                  <span className="menu-arrow" />
                                )}
                              </Link>
                              <ul
                                style={{
                                  display:
                                    subOpen === title?.label ? "block" : "none",
                                }}>
                                {title?.submenuItems?.map(
                                  (item, titleIndex) => (
                                    <li
                                      className="submenu submenu-two"
                                      key={titleIndex}>
                                      <Link
                                        to={item?.link}
                                        className={`${
                                          item?.submenuItems
                                            ?.map((link) => link.link)
                                            .includes(Location.pathname) ||
                                          item?.link === Location.pathname
                                            ? "active"
                                            : ""
                                        } ${
                                          subsidebar === item?.label
                                            ? "subdrop"
                                            : ""
                                        }`}
                                        onClick={() =>
                                          toggleSubsidebar(item?.label)
                                        }>
                                        {item?.label}
                                        {item?.submenu && (
                                          <span className="menu-arrow inside-submenu" />
                                        )}
                                      </Link>
                                      <ul
                                        style={{
                                          display:
                                            subsidebar === item?.label
                                              ? "block"
                                              : "none",
                                        }}>
                                        {item?.submenuItems?.map(
                                          (items, subIndex) => (
                                            <li key={subIndex}>
                                              <Link
                                                to={items?.link}
                                                className={`${
                                                  subsidebar === items?.label
                                                    ? "submenu-two subdrop"
                                                    : "submenu-two"
                                                } ${
                                                  items?.submenuItems
                                                    ?.map((link) => link.link)
                                                    .includes(
                                                      Location.pathname
                                                    ) ||
                                                  items?.link ===
                                                    Location.pathname
                                                    ? "active"
                                                    : ""
                                                }`}>
                                                {items?.label}
                                              </Link>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </li>
                                  )
                                )}
                              </ul>
                            </li>
                          </React.Fragment>
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
      <HorizontalSidebar />
      <CollapsedSidebar />
    </div>
  );
};

export default Sidebar;
